import React, { useCallback, useState } from 'react';

const withOpenState = (WrappedComponent) => {
   return (props = {}) => {
      const [isOpen, setIsOpen] = useState(false);

      const toggleIsOpen = useCallback(() => {
         setIsOpen((prevState) => !prevState);
      }, []);

      const openModal = useCallback(() => {
         setIsOpen(true);
      }, []);

      const closeModal = useCallback(() => {
         setIsOpen(false);
      }, []);

      return (
         <WrappedComponent
            {...props }
            isOpen={isOpen}
            openModal={openModal}
            closeModal={closeModal}
            toggleIsOpen={toggleIsOpen}
         />
      );
   };
};

export default withOpenState;
